import { isValueEmpty } from '@awp/helpers/utilsReact';
import { useSearchParams } from 'react-router-dom';
import { Views } from '@awp/constants';

let _extractId = (location) => {
  let crudId = null;
  let matches = location.match(/\/(\d+)$/);

  if (matches && matches.length && matches.length > 1) {
    crudId = matches[1];
  }

  return crudId;
};

export function getCrudIdFromUrl() {
  if (!window || !window.location) return null;

  return _extractId(window.location.pathname);
}

export let extractId = _extractId;

export const getNumberFromSearchParams = (searchParam, defaultValue = null) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const param = searchParams.get(searchParam);
  if (isValueEmpty(param)) return defaultValue;

  const num = Number(param);
  if (isNaN(num) || num <= 0) return defaultValue;

  return num;
};

export function getListPageParams() {
  try {
    const url = JSON.parse(sessionStorage.getItem('listSearchParams'));
    return url ? `?${url}` : '';
  } catch (e) {
    /* empty */
  }

  return '';
}

export function checkForFullScreen(fullScreenEnabled) {
  if (!window || !window.location) return false;

  return (
    (window.location.pathname === Views.ManualDataValidation ||
      window.location.pathname === Views.DataTable ||
      window.location.pathname === Views.MultiStationGraph ||
      window.location.pathname === Views.Dashboard) &&
    fullScreenEnabled
  );
}
